import { mapGetters } from 'vuex'
import productTrustMixin from '~/mixins/productTrustMixin'
import {
  arraySortStringsByField,
  filterTrustCenterData,
} from '~/logicJs/ArrayUtils'

export default {
  mixins: [productTrustMixin],
  computed: {
    ...mapGetters([
      'GET_TRUST_CENTER_DB',
      'GET_PRODUCTS_TRUST_SELECTED',
      'GET_CURRENT_USER',
      'GET_PRODUCTS_LIST_TRUST',
    ]),

    getTrustCenterDocument() {
      // Removed: email-domain filtering on limitations.privetAccessDomains (domain-limitation capability removed) —
      // documents and links are no longer hidden based on the visitor's email domain
      let GET_TRUST_CENTER_DB = _.cloneDeep(this.GET_TRUST_CENTER_DB)
      let res = GET_TRUST_CENTER_DB.filter(
        (item) => item.type === 'document' || item.type === 'link'
      )
      // add the option to selecet all documents via checkboxs
      res.map((doc) => {
        return { ...doc, isSelected: false }
      })
      console.log(
        'Inside getTrustCenterDocument res: ',
        res,
        this.GET_TRUST_CENTER_DB
      )

      return res
    },
    groups() {
      let res =
        this.GET_TRUST_CENTER_DB.find((item) => item.type === 'group')
          ?.groups ?? []
      return res
    },

    controlsByGroup() {
      let res = this.GET_TRUST_CENTER_DB.find(
        (i) => i.type === 'controls'
      )?.data?.map((item) => item.group)

      return [...new Set(res ?? [])]
    },

    controlsByControlSliced() {
      const slicedData = Object.fromEntries(
        Object.entries(this.controlsByControl)
          .sort(([a], [b]) => a.localeCompare(b))
          .slice(0, this.maxControlsToShow)
          .map(([key, arr]) => [key, filterTrustCenterData(arr, 'control')])
      )

      const selectedId = this.GET_PRODUCTS_TRUST_SELECTED?.id
      if (!selectedId) return slicedData

      const sel = String(selectedId)

      const filtered = Object.fromEntries(
        Object.entries(slicedData).map(([group, controls]) => [
          group,
          controls.filter((c) => {
            // With your new build step, productId exists only when there are ids.
            const pid = c.productId
            if (!pid) return false // exclude when missing

            // Support array or scalar just in case
            return Array.isArray(pid)
              ? pid.some((id) => String(id) === sel)
              : String(pid) === sel
          }),
        ])
      )

      // prune empty groups
      return Object.fromEntries(
        Object.entries(filtered).filter(([, arr]) => arr.length > 0)
      )
    },

    controlsByControl() {
      const grouped = {}

      const controls =
        this.GET_TRUST_CENTER_DB.find((i) => i.type === 'controls')?.data ?? []

      // Sort controls by order field first, then by control name
      const sortedControls = filterTrustCenterData(controls, 'control')

      sortedControls.forEach((item) => {
        const group = item.group
        if (!grouped[group]) {
          grouped[group] = []
        }

        grouped[group].push({
          group: item.group,
          control: item.control,
          description: item.description,
          order: item.order, // Preserve order field
          ...(item?.productIds && { productId: item.productIds }),
        })
      })

      return grouped
    },
    documentsByGroup() {
      let res = []
      let documentsAll = _.cloneDeep(this.getTrustCenterDocument)
      let productId = this.GET_PRODUCTS_TRUST_SELECTED?.id
      if (productId)
        documentsAll = documentsAll.filter(
          (e) => !e.productIds || e.productIds.includes(productId)
        )
      console.log(
        'Inside documentsByGroup - this.getTrustCenterDocument - this.groups: ',
        this.getTrustCenterDocument,
        this.groups
      )
      if (this.groups.length === 0) {
        // sort documents by order field first, then by title
        documentsAll = filterTrustCenterData(documentsAll, 'title')
        return (res = [{ groupeName: '', documents: documentsAll }])
      }
      for (let i = 0; i < this.groups.length; i++) {
        let documents = this.getDocumentByGroupId(
          documentsAll,
          this.groups[i].id
        )
        // sort documents by order field first, then by title
        documents = filterTrustCenterData(documents, 'title')
        res.push({ ...this.groups[i], documents })
      }
      console.log(
        'Inside documentsByGroup - documentsAll, res:',
        documentsAll,
        res
      )
      return res
    },
  },
  methods: {
    getDocumentByGroupId(documents, groupId) {
      // Align with Vendict New
      let res
      if (groupId) {
        res = documents.filter((doc) => doc.groupId === groupId)
      } else {
        res = documents.filter((doc) => !doc.groupId)
      }
      return res
    },
    filterByProductsChecked(list) {
      // If list is not an array or is falsy, return an empty array
      console.log(
        'Inside filterByProductsChecked this.getProductIdChecked, list: ',
        this.getProductIdChecked,
        list
      )
      let res = []
      if (!Array.isArray(list) || !list) {
        res = []
      }

      // If no product is selected (Overall), return the full list (no filtering by product)
      else if (!this.getProductIdChecked) {
        res = list
      }

      // Otherwise (specific product selected), return objects that:
      // 1. Have no productIds or empty productIds
      // 2. Have a productId matching getProductIdChecked
      else
        res = list.filter((item) => {
          if (!item.productIds || item.productIds.length === 0) {
            return true
          }
          return item.productIds.includes(this.getProductIdChecked)
        })

      console.log('Inside filterByProductsChecked res: ', res)
      return res
    },
    getTrustCenterByType(type) {
      let res = null
      let trustByType = this.GET_TRUST_CENTER_DB.find(
        (item) => item.type === type
      )
      if (type === 'trustCenterSettings') {
        console.log(
          'Inside getTrustCenterByType trustCenterSettings, this.GET_PRODUCTS_TRUST_SELECTED?.id: ',
          this.GET_PRODUCTS_TRUST_SELECTED?.id
        )
        let productId = this.GET_PRODUCTS_TRUST_SELECTED?.id
        if (productId && trustByType) {
          const profileOverrides = _.get(trustByType, `profiles.${productId}`, {})
          res = _.merge({}, trustByType, profileOverrides)
        } else {
          res = trustByType // Special case for trustCenterSettings not array but object
        }
      } else {
        res = _.get(trustByType, 'data', [])
      }
      console.log(
        'Inside getTrustCenterByType type, res, this.getProductIdChecked: ',
        type,
        res,
        this.getProductIdChecked
      )

      if (['trustCenterSettings', 'team'].includes(type)) {
        // Sort team by order field first, then by name
        if (type === 'team' && Array.isArray(res)) {
          res = filterTrustCenterData(res, 'name')
        }
        return res
      } else {
        // filter res by this.getProductIdChecked (at least one of the ids must be in the array)
        res = this.filterByProductsChecked(res)
        // Sort certifications and other types by order field first, then by title/name
        if (Array.isArray(res)) {
          const fallbackField = type === 'certifications' ? 'title' : 'title'
          res = filterTrustCenterData(res, fallbackField)
        }
        console.log(
          'Inside getTrustCenterByType type, res, this.getProductIdChecked: ',
          type,
          res,
          this.getProductIdChecked
        )
        return res
      }
    },
    getTitel(type, freeText) {
      return `${freeText} (${this.getTrustCenterByType(type).length})`
    },
    checkIfLengthAtLeastFour(type) {
      let collection = this.getTrustCenterByType(type) ?? []
      if (!_.isArray(collection)) return false
      const items = collection.slice(0, 4)
      return items.length === 4 || items.length > 4
    },

    returnOnlyFirstEntries(type, entries = 4) {
      let collection = this.getTrustCenterByType(type) ?? []
      // Check if collection is an array
      if (_.isArray(collection)) {
        return collection.slice(0, entries)
      }
      // Check if collection is an object
      if (_.isObject(collection)) {
        // Convert object to an array of [key, value] pairs
        return Object.entries(collection).slice(0, entries)
      }
      // If it's neither an array nor an object, return false
      return false
    },
  },
}
